import { defineMessages } from '../define';

/** Каркас приложения: нижняя навигация, быстрый ввод траты. */
export const app = defineMessages({
  ru: {
    'app.budget': 'Бюджет',
    'app.feed': 'Лента',
    'app.payments': 'Платежи',
    'app.newExpense': 'Новая трата',
    'app.sections': 'Разделы',
    'app.undo': 'Отменить',
  },
  en: {
    'app.budget': 'Budget',
    'app.feed': 'Feed',
    'app.payments': 'Payments',
    'app.newExpense': 'New expense',
    'app.sections': 'Sections',
    'app.undo': 'Undo',
  },
  be: {
    'app.budget': 'Бюджэт',
    'app.feed': 'Стужка',
    'app.payments': 'Плацяжы',
    'app.newExpense': 'Новая трата',
    'app.sections': 'Раздзелы',
    'app.undo': 'Скасаваць',
  },
});
